import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ParentPortalService } from "app/services/parentPortal.service";
import { FetchData, resizeImage } from "app/shared/generalMethods";
import { ModalCancelComponent } from "../../modal/modal-cancel/modal-cancel.component";
import { NgForm, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { InputValidation } from "app/shared/inputValidation";
import { UserProfileService } from "app/services/userProfile.service";

@Component({
  selector: "app-manage-profile",
  templateUrl: "./manage-profile.component.html",
  styleUrls: ["./manage-profile.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ManageProfileComponent implements OnInit {
  @ViewChild("parentProfileNgForm") parentProfileNgForm: NgForm;
  profileForm: FormGroup;
  pageLoader: any;
  pageLoaderText: any;
  parentId = null;
  updateBtn = true;
  userRecord: any;
  apiResult: any;
  membershipId: any;
  imagePreviewParent: string | ArrayBuffer | null = null;
  imageError: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _parentPortalService: ParentPortalService,
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _fetchData: FetchData,
    private _inputValidation: InputValidation,
    private _getSalesforceDataService: GetSalesforceDataService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.userRecord = this._fetchData.data.lstParents[0];
    this.membershipId = this._fetchData.data?.lstMembershipProfiles?.[0]?.Id;
    if (this.userRecord) {
      this.parentId = this._fetchData.parentId;
    } else {
    }
  }

  ngOnInit(): void {
    this.setFormValues(this.userRecord);

    const userData = localStorage.getItem("user");
    let googlePhotoUrl: string | null = null;

    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        googlePhotoUrl = parsedUser?.photoURL || null;
      } catch (err) {
        console.error("Error parsing user from localStorage:", err);
      }
    }

    // ✅ Only show Google image if there's no custom one
    const currentImage = this.imagePreviewParent;

    if (
      (!currentImage ||
        currentImage === "assets/images/avatars/user.png" ||
        currentImage === "null") &&
      googlePhotoUrl
    ) {
      this.imagePreviewParent = googlePhotoUrl;

      if (this.profileForm?.get("pgiParentImage")) {
        this.profileForm.patchValue({ pgiParentImage: googlePhotoUrl });
      }
    }
  }

  onInputAlphabet(event: any): void {
    this._inputValidation.onInputAlphabet(event.target);
  }

  onInputNumeric(event: any): void {
    this._inputValidation.onInputNumeric(event.target);
  }

  onInputAlphaNumeric(event: any): void {
    this._inputValidation.onInputAlphaNumeric(event.target);
  }

  setFormValues(response): void {
    if (response.Parent_Image__c) {
      this.imagePreviewParent = response.Parent_Image__c.replace(
        /<\/?p>/g,
        '"'
      ).replace(/&quot;/g, "");
    }

    this.profileForm = this._formBuilder.group({
      pgiFullName: [
        { value: response.Name, disabled: true },
        [Validators.required],
      ],
      community: [
        { value: response.Community__r.Name, disabled: true },
        [Validators.required],
      ],
      pgiPhysicalAddress: [
        response.Physical_Address__c === "null"
          ? ""
          : response.Physical_Address__c,
        [Validators.required],
      ],
      pgiCity: [
        response.Town_City__c === "null" ? "" : response.Town_City__c,
        [Validators.required],
      ],
      pgiHomePhone: [
        { value: response.Home_Phone__c, disabled: true },
        [Validators.required],
      ],
      pgiPostalCode: [
        response.Postal_Code__c === "null" ? "" : response.Postal_Code__c,
        [Validators.required],
      ],
      pgiCellPhone: [
        response.Cell_Phone__c === "null" ? "" : response.Cell_Phone__c,
      ],
      pgiEmail: [
        { value: response.Parent_Email__c, disabled: true },
        [Validators.email, Validators.required],
      ],
      pgiWorkPhone: [
        response.Work_Phone__c === "null" ? "" : response.Work_Phone__c,
      ],
      pgiIsRural: [response.Is_Rural__c === "null" ? "" : response.Is_Rural__c],

      pgiFullNameSp: [
        response.Second_Parent_Name__c === "null"
          ? ""
          : response.Second_Parent_Name__c,
      ],
      pgiPhysicalAddressSp: [
        response.Second_Physical_Address__c === "null"
          ? ""
          : response.Second_Physical_Address__c,
      ],
      pgiCitySp: [
        response.Second_Parent_City__c === "null"
          ? ""
          : response.Second_Parent_City__c,
      ],
      pgiHomePhoneSp: [
        response.Second_Home_Phone__c === "null"
          ? ""
          : response.Second_Home_Phone__c,
      ],
      pgiPostalCodeSp: [
        response.Second_Postal_Code__c === "null"
          ? ""
          : response.Second_Postal_Code__c,
      ],
      pgiCellPhoneSp: [
        response.Second_Cell_Phone__c === "null"
          ? ""
          : response.Second_Cell_Phone__c,
      ],
      pgiEmailSp: [
        response.Second_Parent_Email__c === "null"
          ? ""
          : response.Second_Parent_Email__c,
        [Validators.email],
      ],
      pgiWorkPhoneSp: [
        response.Second_Work_Phone__c === "null"
          ? ""
          : response.Second_Work_Phone__c,
      ],
      pgiParentImage: [
        !response.Parent_Image__c || response.Parent_Image__c === "null"
          ? "assets/images/avatars/user.png"
          : response.Parent_Image__c,
      ],
    });
  }

  clickEdit(): void {
    this.pageLoader = false;
    this.updateBtn = false;
    this.profileForm.get("pgiFullName").enable();
    this.profileForm.get("pgiPhysicalAddress").enable();
    this.profileForm.get("pgiCity").enable();
    this.profileForm.get("community").enable();
    this.profileForm.get("pgiHomePhone").enable();
    this.profileForm.get("pgiPostalCode").enable();
    this.profileForm.get("pgiCellPhone").enable();
    this.profileForm.get("pgiEmail").enable();
    this.profileForm.get("pgiWorkPhone").enable();
    this.profileForm.get("pgiIsRural").enable();
    this.profileForm.get("pgiFullNameSp").enable();
    this.profileForm.get("pgiPhysicalAddressSp").enable();
    this.profileForm.get("pgiCitySp").enable();
    this.profileForm.get("pgiHomePhoneSp").enable();
    this.profileForm.get("pgiPostalCodeSp").enable();
    this.profileForm.get("pgiCellPhoneSp").enable();
    this.profileForm.get("pgiEmailSp").enable();
    this.profileForm.get("pgiWorkPhoneSp").enable();
    this.profileForm.get("pgiParentImage").enable();
  }

  disabledField(): void {
    this.updateBtn = true;
    this.profileForm.get("pgiFullName").disable();
    this.profileForm.get("pgiPhysicalAddress").disable();
    this.profileForm.get("pgiCity").disable();
    this.profileForm.get("community").disable();
    this.profileForm.get("pgiHomePhone").disable();
    this.profileForm.get("pgiPostalCode").disable();
    this.profileForm.get("pgiCellPhone").disable();
    this.profileForm.get("pgiEmail").disable();
    this.profileForm.get("pgiWorkPhone").disable();
    this.profileForm.get("pgiIsRural").disable();
    this.profileForm.get("pgiFullNameSp").disable();
    this.profileForm.get("pgiPhysicalAddressSp").disable();
    this.profileForm.get("pgiCitySp").disable();
    this.profileForm.get("pgiHomePhoneSp").disable();
    this.profileForm.get("pgiPostalCodeSp").disable();
    this.profileForm.get("pgiCellPhoneSp").disable();
    this.profileForm.get("pgiEmailSp").disable();
    this.profileForm.get("pgiWorkPhoneSp").disable();
  }

  onFormSubmit(): void {
    this.pageLoader = true;
    this.pageLoaderText =
      this._fetchData.data.lstAppSettings[0].Loading_message__c;
    const formData = this.profileForm;

    if (formData.valid) {
      this._parentPortalService
        .updateParent(this.profileForm.value, this.parentId)
        .subscribe((response) => {
          this.apiResult = this._fetchData.parseIntoJSON(response.msg);

          if (this.apiResult.data === null) {
            this.redirectUserToMaintenancePage();
          } else {
            if (this.apiResult.success === true) {
              this._fetchData.setLocalStorage(response.msg);

              this.userRecord = this._fetchData.data.lstParents[0];
              this.setFormValues(this.userRecord);

              this.cdr.detectChanges();

              this.disabledField();

              this.pageLoader = false;
              this.openSnackBar("Record has been updated successfully.");
            } else {
              this.updateBtn = false;
              this.pageLoader = false;
              this.openSnackBar(this.apiResult.error.message);
            }
          }
        });
    } else {
      this.pageLoader = false;
      this.updateBtn = false;
      this.pageLoaderText = "Please fill in all the required fields.";
    }
  }

  redirectUserToMaintenancePage(): void {
    this._getSalesforceDataService.redirectUserToMaintenancePage();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openSnackBar(message: string) {
    this._snackBar.open(message, "Close", {
      duration: 4000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  updateSubscription(e): void {
    const dialog = this.dialog.open(ModalCancelComponent, {
      height: "auto",
      width: "auto",
      maxWidth: "750px",
      data: {
        record: "Delete Profile Permanently",
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result?.food === "cancel") {
        // Get UID from localStorage
        const uid = localStorage.getItem("UID");

        // Get membershipId from userRecord
        this.membershipId =
          this._fetchData.data?.lstMembershipProfiles?.[0]?.Id;

        // Check if we have the required data
        if (!uid) {
          this.openSnackBar(
            "Error: User ID not found. Please try logging in again."
          );
          return;
        }

        if (!this.membershipId) {
          this.openSnackBar("Error: Membership information not found.");
          return;
        }

        this.pageLoader = true;
        this.pageLoaderText =
          this._fetchData.data?.lstAppSettings?.[0]?.Loading_message__c ||
          "Loading...";

        this._parentPortalService
          .updateMembershipSubscription(
            this.membershipId,
            e,
            this.parentId,
            uid
          )
          .subscribe(
            (response) => {
              const results: any = this._fetchData.parseIntoJSON(response.msg);

              // Handle partial success (Salesforce deleted but Firebase user not found)
              if (
                results.success === false &&
                results.msg?.includes("failed to remove user from Firebase") &&
                results.error?.includes(
                  "user record corresponding to the provided identifier"
                )
              ) {
                // Salesforce deletion succeeded but Firebase user was already gone
                this.openSnackBar(
                  "Your account has been deleted successfully."
                );
                localStorage.clear();
                this._router.navigate(["/sign-out"]);
              } else if (results.success === true) {
                // Complete success
                this.openSnackBar(
                  "Your account has been deleted successfully."
                );
                localStorage.clear();
                this._router.navigate(["/sign-out"]);
              } else {
                // Actual failure
                this.pageLoader = false;
                this.openSnackBar(
                  "Account could not be deleted: " +
                    (results.msg || "Unknown error")
                );
              }
            },
            (err) => {
              this.pageLoader = false;
              this.openSnackBar(
                "Account could not be deleted. Please try again."
              );
            }
          );
      }
    });
  }

  onFileSelected(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    if (file.size > 1048576) {
      // 1 MB
      this.imageError = true;
      this.imagePreviewParent = null;
      this.profileForm.patchValue({ pgiParentImage: null });
      return;
    }

    this.imageError = false;

    resizeImage(file, 800, 800)
      .then((resizedFile) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (type === "parent") {
            this.imagePreviewParent = reader.result;
            this.profileForm.patchValue({ pgiParentImage: reader.result });
          }
        };
        reader.readAsDataURL(resizedFile);
      })
      .catch(() => {
        this.imageError = true;
      });
  }
}
